import * as types from "./MedicineActionTypes";

// Request actions
export const fetchMedicinesRequest = () => ({
  type: types.FETCH_MEDICINES_REQUEST,
});
export const addMedicineRequest = () => ({type: types.ADD_MEDICINE_REQUEST});
export const updateMedicineRequest = () => ({
  type: types.UPDATE_MEDICINE_REQUEST,
});
// export const deleteMedicineRequest = () => ({
//   type: types.DELETE_MEDICINE_REQUEST,
// });
export const toggleMedicineStatusRequest = () => ({
  type: types.TOGGLE_MEDICINE_STATUS_REQUEST,
});

export const searchMedicinesRequest = () => ({
  type: types.SEARCH_MEDICINES_REQUEST,
});

// Failure actions
export const fetchMedicinesFailure = (error) => ({
  type: types.FETCH_MEDICINES_FAILURE,
  payload: error,
});
export const addMedicineFailure = (error) => ({
  type: types.ADD_MEDICINE_FAILURE,
  payload: error,
});
export const updateMedicineFailure = (error) => ({
  type: types.UPDATE_MEDICINE_FAILURE,
  payload: error,
});
export const deleteMedicineFailure = (error) => ({
  type: types.DELETE_MEDICINE_FAILURE,
  payload: error,
});
export const toggleMedicineStatusFailure = (error) => ({
  type: types.TOGGLE_MEDICINE_STATUS_FAILURE,
  payload: error,
});

export const searchMedicinesFailure = (error) => ({
  type: types.SEARCH_MEDICINES_FAILURE,
  payload: error,
});

// Success actions
export const fetchMedicines = (medicines) => ({
  type: types.FETCH_MEDICINES_SUCCESS,
  payload: medicines,
});
export const addMedicine = (medicine) => ({
  type: types.ADD_MEDICINE_SUCCESS,
  payload: medicine,
});
export const updateMedicine = (medicine) => ({
  type: types.UPDATE_MEDICINE_SUCCESS,
  payload: medicine,
});
export const deleteMedicine = (id) => ({
  type: types.DELETE_MEDICINE_SUCCESS,
  payload: id,
});
export const toggleMedicineStatus = (medicine) => ({
  type: types.TOGGLE_MEDICINE_STATUS_SUCCESS,
  payload: medicine,
});

export const filterMedicines = (query) => {
  return (dispatch, getState) => {
    const {allMedicines} = getState().medicine;
    const filtered = allMedicines.filter((medicine) =>
      medicine.medicineName.toLowerCase().includes(query.toLowerCase())
    );
    dispatch(filterMedicinesLocal(filtered, query));
    return filtered;
  };
};

export const filterMedicinesLocal = (medicines, query) => ({
  type: types.FILTER_MEDICINES_LOCAL,
  payload: medicines,
  meta: {query},
});

export const searchMedicinesSuccess = (medicines, query) => ({
  type: types.SEARCH_MEDICINES_SUCCESS,
  payload: medicines,
  meta: {query},
});
